import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const VentePage: FC = () => {  
    return (
        <Outlet />
    );
}

export default VentePage